import * as React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ColorPicker from './ColorPicker';
import Form from 'react-bootstrap/Form';
import {Action} from '../../../system/buttons';
import {DirectLink} from '../../welcome/Welcome';

export default class RealTimeGraphWidgetEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {...props.configuration};
  }

  handleChange = (property) => (value) => {
    let f = {};
    f[property] = value;
    this.setState(f);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate(this.state);
    }
  }

  render() {
    return (
      <>
        <BasicFormElement label={'Line color'}>
          <ColorPicker
            color={this.state.lineColor}
            onChangeComplete={this.handleChange('lineColor')}
          />
        </BasicFormElement>

        <BasicFormElement label={'Font color'}>
          <ColorPicker
            color={this.state.color}
            onChangeComplete={this.handleChange('color')}
          />
        </BasicFormElement>

        <BasicFormElement label={'Font size'}>
          <Form.Control
            type="number"
            value={this.state.fontSize}
            onChange={(e) => this.handleChange('fontSize')(e.target.value)}
          />
        </BasicFormElement>

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Font
            <div>
              <DirectLink
                text={'choose here'}
                href={'https://fonts.google.com'}
                style={{
                  fontSize: '10px',
                }}
              ></DirectLink>
            </div>
          </Form.Label>
          <Col sm="3">
            <Form.Control
              value={this.state.font}
              onChange={(e) => this.handleChange('font')(e.target.value)}
            />
          </Col>
        </Form.Group>

        <BasicFormElement label={'Lower limit'}>
          <Form.Control
            value={this.state.min ? this.state.min : 50}
            type={'number'}
            onChange={(e) => this.handleChange('min')(parseInt(e.target.value))}
          />
        </BasicFormElement>

        <BasicFormElement label={'Upper limit'}>
          <Form.Control
            value={this.state.max}
            type={'number'}
            onChange={(e) => this.handleChange('max')(parseInt(e.target.value))}
          />
        </BasicFormElement>

        <Action onClick={() => this.props.onSave(this.state)}>
          Save settings
        </Action>
      </>
    );
  }
}

const BasicFormElement = ({label, children}) => {
  return (
    <Form.Group as={Row}>
      <Form.Label column sm="2">
        {label}
      </Form.Label>
      <Col sm="3">{children}</Col>
    </Form.Group>
  );
};
